<template>
	<span
		v-if="!!tooltipMsg"
		class="relative">
		<IconsFontAwesome
			:key="shouldShowTooltip"
			icon="fa-solid fa-circle-exclamation"
			class="ml-1 text-primary cursor-pointer hover:text-secondary hoverEffects"
			:class="{ 'text-secondary': shouldShowTooltip }"
			@mouseenter="showTooltip(true)"
			@mouseleave="showTooltip(false)" />
		<span
			:id="id"
			v-show="shouldShowTooltip"
			class="pointer-events-none absolute top-5 left-5 rounded-lg text-primary bg-black border-2 border-primary p-2 font-normal z-10 w-40">
			{{ tooltipMsg }}
		</span>
	</span>
</template>

<script setup>
	const { id } = defineProps({
		id: {
			type: String,
		},
		tooltipMsg: {
			type: String,
			default: "",
		},
	})

	const shouldShowTooltip = ref(false)

	const showTooltip = (shouldShow) => {
		shouldShowTooltip.value = shouldShow

		if (shouldShow) {
			nextTick(() => {
				closeTooltipOnScroll()
			})
		}
	}

	const adjustPositionToFitScreen = () => {
		const screenWidth = document.documentElement.clientWidth
		const screenHeight = document.documentElement.clientHeight

		const tooltipEl = document.getElementById(id)
		if (!tooltipEl) {
			return
		}
		const dimensions = tooltipEl.getBoundingClientRect()
		// Get item dimensions
		const itemWidth = dimensions.width
		const itemHeight = dimensions.height

		let itemX = dimensions.x
		let itemY = dimensions.y

		// Check if the item fits horizontally
		if (itemX + itemWidth > screenWidth) {
			tooltipEl.style.left = `-${itemWidth}px`
		}

		// Check if the item fits vertically
		if (itemY + itemHeight > screenHeight) {
			tooltipEl.style.top = `-${itemHeight}px`
		}
	}

	const closeTooltipOnScroll = () => {
		//Give some time for the device to render the tooltip on the screen before binding listener
		//Sometimes a mobile device will scroll for the user
		setTimeout(() => {
			window.addEventListener(
				"scroll",
				() => {
					shouldShowTooltip.value = false
				},
				{ once: true }
			)
		}, 1000)
	}

	onMounted(() => {
		fixLastTooltip()
	})

	//Needed to run this method upon loading the page to resolve a rendering issue where the last tooltip on the page was not working upon the first click.
	const fixLastTooltip = () => {
		shouldShowTooltip.value = true
		nextTick(() => {
			adjustPositionToFitScreen()
			shouldShowTooltip.value = false
		})
	}
</script>

<style scoped></style>
